@use "../../styles/breakpoints";

hp6-spacing-vertical {
  display: block;
  height: var(--spacing-md);

  @include breakpoints.xsmall-up {
    &[xs="0"] {
      height: 0;
    }

    &[xs="xxs"] {
      height: var(--spacing-xxs);
    }

    &[xs="xs"] {
      height: var(--spacing-xs);
    }

    &[xs="sm"] {
      height: var(--spacing-sm);
    }

    &[xs="md"] {
      height: var(--spacing-md);
    }

    &[xs="lg"] {
      height: var(--spacing-lg);
    }

    &[xs="xl"] {
      height: var(--spacing-xl);
    }

    &[xs="xxl"] {
      height: var(--spacing-xxl);
    }
  }

  @include breakpoints.small-up {
    &[sm="0"] {
      height: 0;
    }

    &[sm="xxs"] {
      height: var(--spacing-xxs);
    }

    &[sm="xs"] {
      height: var(--spacing-xs);
    }

    &[sm="sm"] {
      height: var(--spacing-sm);
    }

    &[sm="md"] {
      height: var(--spacing-md);
    }

    &[sm="lg"] {
      height: var(--spacing-lg);
    }

    &[sm="xl"] {
      height: var(--spacing-xl);
    }

    &[sm="xxl"] {
      height: var(--spacing-xxl);
    }
  }

  @include breakpoints.medium-up {
    &[md="0"] {
      height: 0;
    }

    &[md="xxs"] {
      height: var(--spacing-xxs);
    }

    &[md="xs"] {
      height: var(--spacing-xs);
    }

    &[md="sm"] {
      height: var(--spacing-sm);
    }

    &[md="md"] {
      height: var(--spacing-md);
    }

    &[md="lg"] {
      height: var(--spacing-lg);
    }

    &[md="xl"] {
      height: var(--spacing-xl);
    }

    &[md="xxl"] {
      height: var(--spacing-xxl);
    }
  }

  @include breakpoints.large {
    &[lg="0"] {
      height: 0;
    }

    &[lg="xxs"] {
      height: var(--spacing-xxs);
    }

    &[lg="xs"] {
      height: var(--spacing-xs);
    }

    &[lg="sm"] {
      height: var(--spacing-sm);
    }

    &[lg="md"] {
      height: var(--spacing-md);
    }

    &[lg="lg"] {
      height: var(--spacing-lg);
    }

    &[lg="xl"] {
      height: var(--spacing-xl);
    }

    &[lg="xxl"] {
      height: var(--spacing-xxl);
    }
  }
}
